import { Directive, OnInit, Input, ContentChild, TemplateRef } from '@angular/core';
import { FarrisColumnTemplateDirective } from './datatable-slot.directive';
@Directive({
    selector: 'data-row'
})
export class RowDirective implements OnInit {
    //    æå®æ¨¡æ¿
    @Input()
    @ContentChild(FarrisColumnTemplateDirective, { read: TemplateRef }) rowTempl: TemplateRef<any>;
    constructor() {
    }
    ngOnInit() {
    }
}
